module.exports = __webpack_public_path__ + "static/media/sbs.9f991cf0.jpeg";